var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{staticClass:"py-0 mt-n2 pl-0 fullscreen"},[_c('iframe',{staticClass:"fullscreen",attrs:{"sandbox":"allow-forms allow-scripts allow-same-origin","src":_vm.link,"allowfullscreen":"allowfullscreen"}})])}
var staticRenderFns = []

export { render, staticRenderFns }